var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',[(_vm.isDebug)?_c('div',[_vm._v(" Debug captcha ")]):_c('recaptcha',{attrs:{"invalid":true},model:{value:(_vm.captcha),callback:function ($$v) {_vm.captcha=$$v},expression:"captcha"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }